"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUPPORTED_CHARTS = void 0;
exports.SUPPORTED_CHARTS = ["pie", "bar", "bar-horizontal", "stacked-bar-horizontal", "line", "scatter", "donut", "stacked-bar"];
exports["default"] = {
  SUPPORTED_CHARTS: exports.SUPPORTED_CHARTS
};